import Main from '@/views/Main.vue'

// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
  path: '/login',
  name: 'login',
  meta: {
    title: '登录 - 源码熊少儿编程平台 '
  },
  component: () => import('@/views/login.vue')
}
//证书查询
export const jszsRouter = {
  path: '/jszs/query.do',
  name: 'login',
  meta: {
    title: '教师证书查询 - 源码熊少儿编程平台 '
  },
  component: () => import('@/views/jszs.vue')
}
//python查询
export const ptRouter = {
  path: '/py-trial',
  name: 'py-trial',
  meta: {
    title: '代码实验室 '
  },
  component: () => import('@/views/peixun/stepByStepProgramTrial.vue')
}
export const registRouter = {
  path: '/regist',
  name: 'regist',
  meta: {
    title: '注册 - 源码熊少儿编程平台'
  },
  component: () => import('@/views/regist.vue')
}
export const opusDetailRouter = {
  path: '/opus-detail',
  name: 'opus-detail',
  meta: {
    title: '源码熊少儿编程平台 - 作品详情'
  },
  component: () => import('@/views/index-page/opusDetail.vue')
}
export const articalDetailRouter = {
  path: '/artical-detail',
  name: 'artical-detail',
  meta: {
    title: '源码熊少儿编程平台 - 编程小新星'
  },
  component: () => import('@/views/index-page/articalDetail.vue')
}
export const showScratchRouter = {
  path: '/peixun/showScratch',
  name: 'showScratch',
  meta: {
    title: '源码熊图形化'
  },
  component: () => import('@/views/peixun/showScratch.vue')
}
export const showPythonRouter = {
  path: '/peixun/showPython',
  name: 'showPython',
  meta: {
    title: '源码熊Python'
  },
  component: () => import('@/views/peixun/showPython.vue')
}

export const showPDF = {
  path: '/showPDF',
  name: 'showPDF',
  meta: {
    title: '源码熊课程'
  },
  component: () => import('@/views/peixun/showPDF.vue')
}
export const showPDF2 = {
  path: '/showPDF2',
  name: 'showPDF2',
  meta: {
    title: '源码熊课程'
  },
  component: () => import('@/views/peixun/showPDF2.vue')
}

export const page403 = {
  path: '/403',
  meta: {
    title: '403-权限不足'
  },
  name: 'error-403',
  component: () => import('@/views/error-page/403.vue')
}

export const page500 = {
  path: '/500',
  meta: {
    title: '500-服务端错误'
  },
  name: 'error-500',
  component: () => import('@/views/error-page/500.vue')
}

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
  path: '/',
  name: 'otherRouter',
  redirect: '/home',
  component: Main,
  children: [
    { path: 'home', title: '首页', name: 'home_index', component: () => import('@/views/home/home.vue') },
    { path: 'classManage', title: '班级管理', name: '', component: () => import('@/views/teacher/classManage.vue') },
    // { path: 'stuManage', title: '课堂点评', name: '', component: () => import('@/views/teacher/stuManage.vue') },
    { path: 'preLesson', title: '教师备课', name: '', component: () => import('@/views/teacher/preLesson.vue') },
    { path: 'courseCenter', title: '课程中心', name: '', component: () => import('@/views/teacher/courseCenter.vue') },
    { path: 'opusSquare', title: '作品广场', name: '', component: () => import('@/views/teacher/opusSquare.vue') },
    { path: 'studentHomework', title: '学生作业', name: '', component: () => import('@/views/teacher/studentHomework.vue') },
    { path: 'studentCloudFile', title: '学生云空间', name: '', component: () => import('@/views/teacher/studentHomework.vue') },
    { path: 'stuManage', title: '学生管理', name: '', component: () => import('@/views/teacher/stuManage.vue') },
    { path: 'personalCenter', title: '个人中心', name: 'personalCenter', component: () => import('@/views/teacher/personalCenter.vue') },
    {
      path: 'courseDetail',
      title: '课程详情',
      name: 'courseDetail',
      component: () => import('../views/teacher/courseDetail.vue')
    },
    {
      path: 'trainCourseDetail',
      title: '师训课程详情',
      name: 'trainCourseDetail',
      component: () => import('../views/teacher/trainCourseDetail.vue')
    },
    { path: 'task-customer', title: '编程挑战', name: 'task-customer_index', component: () => import('@/views/peixun/stepByStepProgram.vue') },
    { path: 'opusDetailNew', title: '作品详情', name: 'opusDetailNew', component: () => import('@/views/teacher/opusDetailNew.vue') },
    { path: 'cloudFileDetailNew', title: '云详情', name: 'cloudFileDetailNew', component: () => import('@/views/teacher/cloudFileDetailNew.vue') },
    { path: 'opusDetail', title: '作品详情', name: 'opusDetail', component: () => import('@/views/teacher/opusDetail.vue') },
    { path: 'activityDetail', title: '活动详情', name: 'activityDetail', component: () => import('@/views/teacher/activityDetail.vue') },
    { path: 'change-pass', title: '修改密码', name: 'change_pass', component: () => import('@/views/change-pass/change-pass.vue') },
    { path: 'message', title: '消息中心', name: 'message_index', component: () => import('@/views/message/message.vue') },
    { path: 'teacher/openCoursePage', title: '公开课', name: 'openCoursePage', component: () => import('@/views/teacher/openCoursePage.vue') },
    { path: 'teacher/activityPage', title: '创作活动', name: 'activityPage', component: () => import('@/views/teacher/activityPage.vue') },
    { path: 'teacher/newOpusPage', title: '最新作品', name: 'tb-newOpusPage', component: () => import('@/views/teacher/newOpusPage.vue') },
    { path: 'teacher/stuOpus', title: '作品列表', name: 'stuOpus', component: () => import('@/views/teacher/stuOpus.vue') },
    { path: 'teacher/techTrain', title: '师训列表', name: 'techTrain', component: () => import('@/views/teacher/techTrain.vue') },
    { path: 'teacher/techTrainDetail', title: '师训详情', name: 'techTrainDetail', component: () => import('@/views/teacher/techTrainDetail.vue') },
    { path: 'teacher/techTrainCourseList', title: '师训课题列表', name: 'techTrainCourseList', component: () => import('@/views/teacher/techTrainCourseList.vue') },
    { path: 'teacher/questionDetail', title: '问题详情', name: 'questionDetail', component: () => import('@/views/teacher/questionDetail.vue') },
    { path: 'teacher/followQuestion', title: '我关注的问题', name: 'followQuestion', component: () => import('@/views/teacher/followQuestion.vue') },
    { path: 'teacher/questionOfMine', title: '我的问题', name: 'questionOfMine', component: () => import('@/views/teacher/questionOfMine.vue') }
  ]
}

export const fullScreenPdf = {
  path: '/peixun/fullScreenPdf',
  name: 'fullScreenPdf',
  meta: {
    title: '源码熊少儿编程平台'
  },
  component: () => import('@/views/peixun/fullScreenPdf.vue')
}
export const appRouter = []

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
  ptRouter,
  loginRouter,
  jszsRouter,
  otherRouter,
  ...appRouter,
  page500,
  page403,
  registRouter,
  opusDetailRouter,
  articalDetailRouter,
  showScratchRouter,
  showPythonRouter,
  showPDF,
  showPDF2,
  fullScreenPdf
]



// WEBPACK FOOTER //
// ./src/router/router.js